import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { urls } from "../../urls";
import { AssistantPanelContext } from "./assistantPanelContext";

export const useCreateProcurementWithAi = (projectId?: string): (() => void) | null => {
  const panel = useContext(AssistantPanelContext);
  const navigate = useNavigate();
  if (!panel?.openWithQuestion || !panel.openOnPage) return null;
  const openOnPage = panel.openOnPage;
  return () => {
    navigate(urls.app.createProcurementWithAi(projectId));
    openOnPage();
  };
};
